var map = {
	"./V.png": 5774,
	"./account/my-sb.png": 52373,
	"./arrow-filled.png": 18467,
	"./back.png": 92550,
	"./banner/banner1.png": 58730,
	"./banner/banner2.png": 16091,
	"./classicphone.png": 97829,
	"./clear.png": 68508,
	"./close.png": 84710,
	"./default-device.png": 2449,
	"./defaultCover.png": 51569,
	"./dji-store.png": 90026,
	"./emoji.png": 30270,
	"./empty.png": 3020,
	"./hardware-empty-icon.png": 4700,
	"./link.png": 99388,
	"./logo.png": 20300,
	"./photo-default-audit.png": 61840,
	"./photo-default-cover.png": 76638,
	"./photo.png": 9740,
	"./play-icon.png": 46702,
	"./play.png": 55010,
	"./publish-succcess-icon.png": 60248,
	"./sort-dorp-down-active.png": 47770,
	"./sort-dorp-down.png": 7644,
	"./video-default-cover.png": 61504,
	"./video.png": 22948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56680;